import { CreateIndex, Token } from './types';

import { createIndex } from './create.index';

export function createUniqueIndex(tokens: Token[]): CreateIndex {
  return createIndex(tokens, true);
}
